interface WarningIconProps {
  width?: number
}

export function WarningIcon({ width = 16 }: WarningIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73209 3.06665C8.96229 1.73332 7.03779 1.73332 6.26799 3.06665L1.07184 12.0667C0.302036 13.4 1.26429 15.0666 2.80389 15.0666H13.1962C14.7358 15.0666 15.698 13.4 14.9282 12.0666L9.73209 3.06665ZM8.86516 7.91426V6.65063C8.86516 6.34242 8.80865 6.0736 8.69565 5.84416C8.58264 5.61472 8.35833 5.5 8.02274 5.5C7.69056 5.5 7.46455 5.61301 7.34469 5.83902C7.22826 6.06161 7.17004 6.32872 7.17004 6.64035V7.89371L7.43715 9.55801C7.43715 9.79087 7.47139 9.99292 7.53988 10.1641C7.6118 10.3354 7.77275 10.421 8.02274 10.421C8.27272 10.421 8.43196 10.3354 8.50045 10.1641C8.57236 9.99292 8.60832 9.79087 8.60832 9.55801L8.86516 7.91426ZM8.64428 12.4859C8.79153 12.3455 8.86516 12.1298 8.86516 11.8387C8.86516 11.5442 8.79496 11.3302 8.65455 11.1966C8.51757 11.0631 8.30697 10.9963 8.02274 10.9963C7.74878 10.9963 7.53817 11.0631 7.39092 11.1966C7.24367 11.3302 7.17004 11.5442 7.17004 11.8387C7.17004 12.4072 7.45427 12.6914 8.02274 12.6914C8.28984 12.6914 8.49703 12.6229 8.64428 12.4859Z"
        fill="currentColor"
      />
    </svg>
  )
}
